import { API_URI } from '../../constants/env';
import { INew, INewsCategory } from '../../types';
import instance from './axios';

const ENDPOINTS = {
  NEWS: '/news',
  NEWS_CATEGORIES: '/news-categories',
};

type NewsProps = {
  search?: string;
  page?: number;
  limit?: number;
};

type NewsCategoriesProps = {
  search?: string;
  parent?: number;
};

const getNews = ({ page = 1, limit = 6, ...props }: NewsProps) => {
  return instance.get<{
    total: number;
    last_page: number;
    news: INew[];
  }>(ENDPOINTS.NEWS, {
    params: {
      page,
      limit,
      ...props,
    },
  });
};

const getNewsDetail = (id: number) => {
  return instance.get<INew>(ENDPOINTS.NEWS + '/' + id);
}

const getNewsCategories = ({ search, parent }: NewsCategoriesProps) => {
  return instance.get<INewsCategory[]>(ENDPOINTS.NEWS_CATEGORIES, {
    baseURL: API_URI + '/wp-json/kcc/v1',
    params: { search, parent },
  });
};

export const NewApi = {
  getNews,
  getNewsDetail,
  getNewsCategories,
};
